import React from 'react';
import PropTypes from 'prop-types';
import { REGEXP_ONLY_DIGITS } from 'input-otp';
import { InputOTP, InputOTPGroup, InputOTPSlot } from 'components/ui/input-otp';
import { cn } from 'lib/utils';

const slotClassName =
  'h-12 w-[42px] rounded-[7px] border border-[#ccd6cf] bg-white text-[22px] font-medium text-[#263e2e] first:border-l data-[active=true]:border-[#287c50] data-[active=true]:ring-[3px] data-[active=true]:ring-[#287c50]/[0.08] max-[380px]:h-11 max-[380px]:w-[35px]';

const EcobankOtpInput = ({ id, label, value, onChange, disabled = false, error = null, autoFocus = false }) => {
  const errorId = `${id}-error`;

  return (
    <div className="space-y-2">
      <label htmlFor={id} className="block text-sm font-medium text-[#34483b]">
        {label}
      </label>
      <InputOTP
        id={id}
        name={id}
        aria-label={label}
        aria-describedby={error ? errorId : undefined}
        aria-invalid={Boolean(error)}
        maxLength={6}
        pattern={REGEXP_ONLY_DIGITS}
        inputMode="numeric"
        autoComplete="one-time-code"
        pushPasswordManagerStrategy="none"
        value={value}
        onChange={onChange}
        disabled={disabled}
        autoFocus={autoFocus}
        containerClassName={cn('gap-[23px] max-[380px]:gap-[15px]', error && '[&_[data-otp-slot]]:border-destructive')}
      >
        <InputOTPGroup data-otp-group className="gap-[7px] max-[380px]:gap-[5px]">
          <InputOTPSlot data-otp-slot index={0} className={slotClassName} />
          <InputOTPSlot data-otp-slot index={1} className={slotClassName} />
          <InputOTPSlot data-otp-slot index={2} className={slotClassName} />
        </InputOTPGroup>
        <InputOTPGroup data-otp-group className="gap-[7px] max-[380px]:gap-[5px]">
          <InputOTPSlot data-otp-slot index={3} className={slotClassName} />
          <InputOTPSlot data-otp-slot index={4} className={slotClassName} />
          <InputOTPSlot data-otp-slot index={5} className={slotClassName} />
        </InputOTPGroup>
      </InputOTP>
      {error && (
        <p id={errorId} className="text-sm leading-5 text-destructive" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

EcobankOtpInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.node,
  autoFocus: PropTypes.bool,
};

export default EcobankOtpInput;
